import { hWebCrossUpperLeft, hWebCrossUpperLeft2, hWebCrossUpperRight } from '../lace/hWebCross'
import { middleSidePartOfWeb, topSidePartOfWeb } from './parts/sideParts'

export const hWebWithEdge = (ctx: CanvasRenderingContext2D, webColor: string, edgeColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // 捕球面とウェブ横2を繋ぐ革紐
  hWebCrossUpperLeft(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperLeft(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperLeft2(ctx, laceColor, 0, 0) // クロス部分の左
  hWebCrossUpperLeft2(ctx, laceColor, -3, 3) // クロス部分の左
  // ウェブ横2
  middleSidePartOfWeb(ctx, webColor, stitchColor, 5, 10)
  // ウェブ縦
  ctx.beginPath()
  ctx.moveTo(240, 233) // 左＿上
  ctx.quadraticCurveTo(254, 267, 254, 267) // 左＿下
  ctx.quadraticCurveTo(265, 243, 293, 208) // 右＿下
  ctx.quadraticCurveTo(283, 168, 283, 168) // 右＿上
  ctx.quadraticCurveTo(254, 199, 240, 233) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ヘリ革＿左
  ctx.fillStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(241, 233) // 左＿上
  ctx.quadraticCurveTo(255, 267, 255, 267) // 左＿下
  ctx.quadraticCurveTo(260, 256, 260, 256) // 右＿下
  ctx.quadraticCurveTo(245, 220, 245, 220) // 右＿上
  ctx.quadraticCurveTo(241, 233, 241, 233) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // // ヘリ革＿右
  ctx.beginPath()
  ctx.moveTo(275, 176) // 左＿上
  ctx.quadraticCurveTo(286, 218, 286, 218) // 左＿下
  ctx.quadraticCurveTo(293, 208, 293, 208) // 右＿下
  ctx.quadraticCurveTo(283, 168, 283, 168) // 右＿上
  ctx.quadraticCurveTo(275, 176, 275, 176) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ウェブ横1(先端)
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)

  // stitchここから
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 縦＿左
  ctx.moveTo(248, 222) // 上
  ctx.quadraticCurveTo(261, 253, 261, 253) // 下
  // 縦＿右
  ctx.moveTo(274, 181) // 上
  ctx.quadraticCurveTo(283, 217, 283, 217) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
}
